<template>
    <v-card width="100%">
      <v-text-field 
        class="px-5" 
        v-model="search" 
        append-icon="mdi-magnify" 
        label="Buscar estudiante" 
        single-line 
        hide-details
      ></v-text-field>
      
      <v-data-table 
        height="300px" 
        fixed-header 
        :search="search" 
        :headers="headers" 
        :items="processedReplies" 
        item-key="id" 
        class="m-3 elevation-1"
      >
        <template v-slot:no-data>
          <p>Nadie ha realizado la actividad.</p>
        </template>
        
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="showDetails(item)">
            <v-icon color="primary" outlined>mdi-eye</v-icon>
          </v-btn>
        </template>
        
        <template v-slot:item.total_time="{ item }">
          {{ formatTime(item.time) }}
        </template>
        
        <template v-slot:item.completion_status="{ item }">
          <v-chip 
            :color="getCompletionColor(item)" 
            small
            class="white--text"
          >
            {{ isCompleted(item) ? 'Completado' : 'Incompleto' }}
          </v-chip>
        </template>
      </v-data-table>
  
      <HabilidadesDigitalesStudentReply
        :modalOpen.sync="showModal"
        :reply="currentReply"
        :pollActivity="pollActivity"
        :questions="questions"
      />
    </v-card>
  </template>
  
  <script>
  import HabilidadesDigitalesStudentReply from './HabilidadesDigitalesStudentReply';
  
  export default {
    props: {
      replies: {
        type: Array,
        required: true
      },
      pollActivity: {
        type: Object,
        required: true
      },
      questions: {
        type: [Array, Object],
        required: true
      }
    },
    components: { 
      HabilidadesDigitalesStudentReply 
    },
    data() {
      return {
        search: '',
        showModal: false,
        currentReply: null,
        headers: [
          { text: 'Nombre', value: 'student.name', sortable: true },
          { text: 'Apellido', value: 'student.lastName', sortable: true },
          { text: 'Tiempo', value: 'total_time', sortable: true },
          { text: 'Estado', value: 'completion_status', sortable: true },
          { text: 'Ver datos', value: 'actions', sortable: false }
        ],
        sectionNames: ["Datos Generales", "Habilidades Digitales"]
      };
    },
    computed: {
      processedReplies() {
        return this.replies.map(reply => ({
          ...reply
        }));
      },
      questionsFlat() {
        // Si questions ya es un array plano, simplemente lo devolvemos
        if (!Array.isArray(this.questions[0])) {
          return this.questions;
        }
        
        // Si está dividido en secciones, lo aplanamos
        return [
          ...(this.questions[0] || []),
          ...(this.questions[1] || [])
        ];
      }
    },
    methods: {
      isCompleted(item) {
        // Verificar si todas las preguntas tienen respuesta
        if (!item.answer) return false;
        
        return this.questionsFlat.every(question => {
          const answer = item.answer[question.id];
          if (!answer) return false;
          
          if (question.type === 'multiple_choice') {
            return answer.answerId && answer.answerId.length > 0;
          } else {
            return answer.answerId !== null && answer.answerId !== undefined;
          }
        });
      },
      getCompletionColor(item) {
        return this.isCompleted(item) ? 'success' : 'warning';
      },
      formatTime(seconds) {
        if (!seconds || seconds < 0) return 'N/A';

        const totalSeconds = Math.floor(seconds); // Redondear correctamente
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return minutes > 0
        ? `${minutes}m${remainingSeconds}s`
        : `${remainingSeconds}s`;
      },
      showDetails(item) {
        this.currentReply = item;
        this.showModal = true;
      }
    }
  };
  </script>
  